import React from "react";

export default function Divider() {
  return (
    <div className="w-full bg-retro-sparkle-line h-32 bg-center bg-no-repeat bg-[length:300%_250px] sm:bg-[length:100%_250px]"></div>
  );
}
